(function () {
  function rootQuery(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function rootQueryAll(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function getConfig(root) {
    var script = rootQuery(root, '[data-memorial-wizard-config]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Memorial wizard config parse error', error);
      return null;
    }
  }

  function exactVariant(config, state) {
    return config.variants.find(function (variant) {
      return config.optionNames.every(function (optionName, index) {
        if (!state[optionName]) return true;
        return variant.options[index] === state[optionName];
      });
    }) || null;
  }

  function variantForCandidate(config, state, optionName, candidateValue) {
    var candidateState = Object.assign({}, state);
    candidateState[optionName] = candidateValue;

    return config.variants.find(function (variant) {
      if (!variant.available) return false;
      return config.optionNames.every(function (name, index) {
        if (!candidateState[name]) return true;
        return variant.options[index] === candidateState[name];
      });
    }) || null;
  }

  function setActiveMedia(root, mediaId) {
    if (!mediaId) return;

    rootQueryAll(root, '[data-media-id]').forEach(function (item) {
      item.classList.toggle('is-active', String(item.getAttribute('data-media-id')) === String(mediaId));
    });

    rootQueryAll(root, '[data-thumb-media-id]').forEach(function (thumb) {
      var active = String(thumb.getAttribute('data-thumb-media-id')) === String(mediaId);
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');

      if (active && typeof thumb.scrollIntoView === 'function') {
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    });
  }

  function sync(root, config, state) {
    var variantIdInput = rootQuery(root, '[data-variant-id-input]');
    var priceEl = rootQuery(root, '[data-wizard-price]');
    var compareEl = rootQuery(root, '[data-wizard-compare]');
    var statusEl = rootQuery(root, '[data-wizard-status]');
    var submitButton = rootQuery(root, '[data-submit]');
    var submitLabel = rootQuery(root, '[data-submit-label]');

    rootQueryAll(root, '[data-option-name][data-option-value]').forEach(function (button) {
      var optionName = button.getAttribute('data-option-name');
      var optionValue = button.getAttribute('data-option-value');
      var isSelected = state[optionName] === optionValue;
      var candidateVariant = variantForCandidate(config, state, optionName, optionValue);
      var isAvailable = Boolean(candidateVariant);

      button.classList.toggle('is-selected', isSelected);
      button.classList.toggle('is-unavailable', !isAvailable);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      button.disabled = !isAvailable && !isSelected;
    });

    var selectedVariant = exactVariant(config, state);

    if (selectedVariant) {
      if (variantIdInput) variantIdInput.value = selectedVariant.id;
      if (priceEl) priceEl.textContent = selectedVariant.priceMoney || '';

      if (compareEl) {
        if (selectedVariant.compareAtMoney && selectedVariant.compareAtMoney !== selectedVariant.priceMoney) {
          compareEl.textContent = selectedVariant.compareAtMoney;
          compareEl.classList.remove('is-hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('is-hidden');
        }
      }

      if (submitButton) submitButton.disabled = !selectedVariant.available;
      if (submitLabel) submitLabel.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';
      if (statusEl) statusEl.textContent = selectedVariant.available ? '' : 'This combination is currently sold out.';

      if (selectedVariant.featuredMediaId) {
        setActiveMedia(root, selectedVariant.featuredMediaId);
      }
    } else {
      if (variantIdInput) variantIdInput.value = '';
      if (submitButton) submitButton.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Unavailable';
      if (statusEl) statusEl.textContent = 'This option combination is unavailable. Please pick another combination.';
    }
  }

  function initWizard(root) {
    var config = getConfig(root);
    if (!config) return;

    var state = {};

    rootQueryAll(root, '[data-option-name][data-option-value].is-selected').forEach(function (button) {
      state[button.getAttribute('data-option-name')] = button.getAttribute('data-option-value');
    });

    rootQueryAll(root, '[data-option-name][data-option-value]').forEach(function (button) {
      button.addEventListener('click', function () {
        var optionName = button.getAttribute('data-option-name');
        var optionValue = button.getAttribute('data-option-value');
        state[optionName] = optionValue;
        sync(root, config, state);
      });
    });

    rootQueryAll(root, '[data-thumb-media-id]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActiveMedia(root, thumb.getAttribute('data-thumb-media-id'));
      });
    });

    sync(root, config, state);
  }

  document.addEventListener('DOMContentLoaded', function () {
    rootQueryAll(document, '[data-memorial-wizard]').forEach(initWizard);
  });
})();
